/**
 * Alertas — os cortes numéricos dos quadros "Precisa de atenção".
 *
 * ── Extraído da `ConfigCrmPage` em 2026-08-03 (K-3)
 *
 * A `ConfigCrmPage` tinha **1905 linhas** e 10 abas num arquivo só. Cada aba
 * virou um item do menu da Configurações, e o painel da casca renderiza este
 * componente direto — sem passar por ela.
 *
 * A extração é passo PRÓPRIO, antes da migração, de propósito: separar "mover
 * código" de "mudar comportamento" é o que permite ler o diff de cada um.
 */
/**
 * CRM v2 — Configurações > Comercial > CRM (PRD §7).
 *
 * TODO parâmetro do Comercial mora aqui: catálogo de serviços · fases ·
 * status de lead · origens · campos obrigatórios por fase · tipos de
 * atividade · motivos de perda/descarte · documentos do Ganho · tags ·
 * construtor de automações · visibilidade por perfil · carteira (ownership).
 * (Metas têm tela própria em Comercial → Metas.)
 */

import {useState} from 'react';

import {Button, Card, HelpTip, Input, Label, useToast} from '@/components/ui';
import {useConfigAlertas, useSalvarConfigAlertas} from '@/lib/crm/crm-store';
import {useAuth} from '@/contexts/AuthContext';
// O14: dropdowns de usuário do comercial listam SÓ o departamento comercial.
// O7: config completa do Orçamento (markups, régua, faixas, kits, taxas).
// A7: Modelos de orçamento nomeados (aba própria — grid de cards + drawer).
// R3: Reciclagem de leads (aba própria — leads parados voltam pro pool/redistribuição).
// Bloco C: Lembretes de atividade agendada (liga/desliga + antecedência).


export function AbaAlertas() {
  const { user } = useAuth();
  const isAdmin = Boolean(user?.isAdmin);
  const { data } = useConfigAlertas();
  const salvar = useSalvarConfigAlertas();
  const toast = useToast();
  const [diasParado, setDiasParado] = useState('');
  const [diasSemProposta, setDiasSemProposta] = useState('');

  // Semeia os campos quando a config chega (sem localStorage — só estado local).
  const [semeado, setSemeado] = useState(false);
  if (data && !semeado) {
    setDiasParado(String(data.diasParado));
    setDiasSemProposta(String(data.diasSemProposta));
    setSemeado(true);
  }

  async function onSalvar() {
    const p = Number(diasParado);
    const s = Number(diasSemProposta);
    if (!Number.isInteger(p) || p < 1 || !Number.isInteger(s) || s < 1) {
      toast.show('Informe números inteiros de 1 dia ou mais.', { variant: 'error' });
      return;
    }
    try {
      await salvar.mutateAsync({ diasParado: p, diasSemProposta: s });
      toast.show('Alertas atualizados.');
    } catch {
      toast.show('Não foi possível salvar os alertas.', { variant: 'error' });
    }
  }

  return (
    <div className="max-w-xl">
      <Card variant="flat" className="p-4 min-w-0">
        <h3 className="text-base font-bold text-ink-1 dark:text-ink-dark-1 mb-1 inline-flex items-center gap-1.5">
          Quando avisar que algo está parado
          <HelpTip texto="Os cortes que definem quando uma proposta ou lead entra nos quadros 'Precisa de atenção' dos Indicadores." />
        </h3>
        <p className="text-sm text-ink-3 dark:text-ink-dark-3 mb-4">
          Estes números valem para os quadros de atenção no Resumo dos Indicadores.
          {!isAdmin && ' Apenas administradores podem alterar.'}
        </p>

        <div className="space-y-4">
          <div>
            <Label className="inline-flex items-center gap-1.5">
              Dias sem interação para marcar proposta como parada
              <HelpTip texto="Uma proposta sem nenhum registro (ligação, visita, nota) por este número de dias entra no quadro 'Paradas'." />
            </Label>
            <Input
              type="number"
              inputMode="numeric"
              min={1}
              value={diasParado}
              onChange={(e) => setDiasParado(e.target.value)}
              disabled={!isAdmin}
              wrapperClassName="w-32"
              aria-label="Dias para proposta parada"
            />
          </div>
          <div>
            <Label className="inline-flex items-center gap-1.5">
              Dias com o lead sem gerar proposta para alertar
              <HelpTip texto="Um lead que está com um vendedor há este número de dias sem virar proposta entra no quadro de leads que precisam de atenção." />
            </Label>
            <Input
              type="number"
              inputMode="numeric"
              min={1}
              value={diasSemProposta}
              onChange={(e) => setDiasSemProposta(e.target.value)}
              disabled={!isAdmin}
              wrapperClassName="w-32"
              aria-label="Dias com lead sem proposta"
            />
          </div>
        </div>

        {isAdmin && (
          <div className="mt-5">
            <Button onClick={onSalvar} disabled={salvar.isPending}>
              {salvar.isPending ? 'Salvando…' : 'Salvar'}
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
}
